"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CuratedListEntity_1 = __importDefault(require("./CuratedListEntity"));
const connector_1 = __importDefault(require("../connector"));
class CuratedList extends CuratedListEntity_1.default {
    constructor(appAddress, subgraphUrl, verbose = false) {
        super(new connector_1.default(subgraphUrl, verbose));
        this.appAddress = appAddress;
    }
    async members({ first = 1000, skip = 0 } = {}) {
        return this._connector.membersForApp(this.appAddress, first, skip);
    }
    onMembers(callback) {
        return this._connector.onMembersForApp(this.appAddress, callback);
    }
}
exports.default = CuratedList;
//# sourceMappingURL=CuratedList.js.map